import { useState, type FormEvent } from 'react'

import { requestPasswordReset } from '../../api/auth'
import { AuthShell } from './AuthShell'

type ForgotPasswordScreenProps = {
  onBack: () => void
}

export const ForgotPasswordScreen = ({ onBack }: ForgotPasswordScreenProps) => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setLoading(true)
    setError(null)
    setMessage(null)
    try {
      await requestPasswordReset(email.trim())
      setMessage('Если email зарегистрирован, мы отправили ссылку для сброса пароля.')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось отправить запрос')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell
      title="Сброс пароля"
      subtitle="Введите email — пришлём ссылку для нового пароля"
      onBack={onBack}
    >
      <form className="pwa-auth__form" onSubmit={handleSubmit}>
        <label className="echat-field">
          <span className="echat-field__label">Email</span>
          <input
            className="echat-field__input"
            type="email"
            autoComplete="email"
            placeholder="Введите email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        {message ? <p className="pwa-auth__message" role="status">{message}</p> : null}
        {error ? (
          <p className="echat-error" role="alert">
            {error}
          </p>
        ) : null}

        <button
          type="submit"
          className="echat-btn echat-btn--primary"
          disabled={loading || !email.trim()}
        >
          {loading ? 'Отправка…' : 'Отправить ссылку'}
        </button>
      </form>

      <div className="pwa-auth__links pwa-auth__links--center">
        <button type="button" className="pwa-auth__link" onClick={onBack}>
          ← Вернуться ко входу
        </button>
      </div>
    </AuthShell>
  )
}
